"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatOptions = void 0;
var formatOptions = function (data) {
    var input = __assign({}, data);
    var optionsRegex = /option(\d+)(.*)/;
    var keys = Object.keys(input).filter(function (key) { return optionsRegex.test(key); });
    keys.forEach(function (key) {
        var property = key.match(optionsRegex);
        if (!property) {
            return;
        }
        var propertyIndex = +property[1] - 1;
        var rest = property[2];
        var propertyKey = "options".concat(rest);
        if (!input[propertyKey]) {
            input[propertyKey] = [];
        }
        var options = input[propertyKey];
        options[propertyIndex] = input[key];
        delete input[key];
    });
    return input;
};
exports.formatOptions = formatOptions;
